import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import {SitemapStyle} from './../../../styles'
import { withLoader } from '../../../hoc/withLoader'

class Sitemap extends Component {
  state = {
    data: {}
  }

  render () {
    const { data, isReady } = this.props
    return (
      <div className={`sitemap ${SitemapStyle} transition ${isReady ? 'transition--ready' : ''}`}>
        <div className="page-inner">
          {
           data && Object.keys(data).map((title, index) => (
              <div className="sitemap-row flex" key={index}>
                <div className="sitemap-title">
                  {title}
                </div>
                <div className="sitemap-categories flex">
                  {
                    data[title].categories.map((category, category_index) => (
                      <div className="sitemap-category" key={category_index}>
                        <div className="category"> {category.name} </div>
                        <ul className="sitemap-link reset">
                          {
                            category.pages.map((page, page_index) => (
                              <li key={page_index}>  <Link to={page.url}> {page.label} </Link> </li>
                            ))
                          }
                        </ul>
                      </div>
                    ))
                  }
                </div>
              </div>
            ))
          }

        </div>
      </div>
    )
  }
}

export default withLoader(Sitemap)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Sitemap.js